module.exports = __webpack_public_path__ + "img/logo-menu-branco.ca5daa93.png";